import { Component, OnInit } from '@angular/core';
import { forEach } from 'lodash';
import { AuthService } from '../../Services/auth.service';
import { OrderService } from '../../Services/order.service';


@Component({
  selector: 'app-order-list-member',
  template: require('./order-list-member.component.html'),
  styles: [require('./order-list-member.component.css')]
})
export class OrderListMemberComponent implements OnInit {

  constructor( private orderService:OrderService, private auth: AuthService) { }

  current_member: any ={
    firstName: "",
    lastName: "",
    id: -1
  };

  memberOrders:any = []
  currentYear = new Date().getFullYear();
  orderYears: any=[]
  // totalAmount:number = 0;
  // totalPrice:number = 0;
  // totalAmountDiscount: number=0;
  // totalAmountPayed: number=0;
  orders_by_cartId: any = {};
  cartIdKeys: any[] =[];

  totalsByCartId: any={}

  ngOnInit() {
    setTimeout(() => {
      this.current_member.firstName = this.auth.membersRusUser.firstName
      this.current_member.lastName = this.auth.membersRusUser.lastName
      this.current_member.id = this.auth.membersRusUser.id
      this.getOrderYearsForMember();
      // this.getData();
    },500);
  }

  // ngAfterViewInit(){
  //   console.log("ngAfterViewInit");
  //   console.log("current Year: ",this.currentYear);
  //   console.log("order years:", this.orderYears);
  // }

  private getOrderYearsForMember(){
    this.orderService.getOrderYearsForMember(this.current_member.id).subscribe ( res =>{
    
      if (res.status == 200){
        this.orderYears = res.value.reverse();
        if (this.orderYears.length > 0){
          this.currentYear = this.orderYears[0]
          this.getData()
        }
      }
     
    })
  }

  private getData(){
    this.orderService.getCartItemsForMemberIdAndYear(this.current_member.id, this.currentYear).subscribe ( res =>{
      if (res.status == 200){
        res.value.forEach( (r:any)=>{
          if (!this.orders_by_cartId.hasOwnProperty(r.cartId)){
            this.orders_by_cartId[r.cartId] = [];
            this.cartIdKeys.push(r.cartId)
          }

          if (!this.totalsByCartId.hasOwnProperty(r.cartId)){
            this.totalsByCartId[r.cartId]={}
            this.totalsByCartId[r.cartId]['totalAmountCount'] = 0;
           
          }
          
          this.orders_by_cartId[r.cartId].push(r)
          this.totalsByCartId[r.cartId]['totalAmountCount'] += r.amount

        })
      }
    });
  }

  yearSelected(){
    this.clearData()
    this.getData()
  }

  private clearData(){
    this.orders_by_cartId = {};
    this.cartIdKeys =[];
    this.totalsByCartId={}
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/order-list-member/order-list-member.component.ts